// All Users are considered External by default
// Our current Internal Users are
// 1. Users inside of Duerr Dental (we assign them the access type manually)
// 2. DDNet users (We automatically assign them this access type when they logged into VSM)
export enum AccessType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}
